import React from 'react'
import { useSelector } from 'react-redux'

// Constants
import { EXPANDED_CASH_POSITION_EVENT } from '../../../../../constants/client/clientEvents'
import { ExpandedShouldYouSellCashPosition } from '../../../../../constants/trackingEvents'

// Components
import { If, ExpandablePanel } from '../../../..'
import { GoodCashPositionLabel, GoodCashPositionBody } from './Good'
import { BadCashPositionLabel, BadCashPositionBody } from './Bad'

// Selectors
import {
  selectCashPositionRelevant,
  selectCashPositionGood,
} from '../../../../../store/selectors/shouldYouSell'

// Styles
import baseStyles from '../ShouldYouSell.module.scss'

const CashPosition = () => {
  const relevant = useSelector(selectCashPositionRelevant)
  const goodCashPosition = useSelector(selectCashPositionGood)
  return (
    <If condition={relevant}>
      <ExpandablePanel
        data-qa='cash-position'
        eventName={EXPANDED_CASH_POSITION_EVENT}
        googleAnalyticsEventName={ExpandedShouldYouSellCashPosition}
        className={baseStyles.panel}
      >
        <ExpandablePanel.Label>
          {goodCashPosition ? (
            <GoodCashPositionLabel />
          ) : (
            <BadCashPositionLabel />
          )}
        </ExpandablePanel.Label>
        <ExpandablePanel.Body>
          {goodCashPosition ? (
            <GoodCashPositionBody />
          ) : (
            <BadCashPositionBody />
          )}
        </ExpandablePanel.Body>
      </ExpandablePanel>
    </If>
  )
}

export default CashPosition
